import { render, staticRenderFns } from "./FeedbackReplyForAdminListItem.vue?vue&type=template&id=c8958b2c&"
import script from "./FeedbackReplyForAdminListItem.vue?vue&type=script&lang=js&"
export * from "./FeedbackReplyForAdminListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSpacer})
